// Reusable mixins
// See https://vuejs.org/v2/guide/mixins.html

const appMixins = {
  methods: {
    /**
     * @name  emitMessageEvent
     * @description Emit a 'message' event on the window.photoClaim instance.
     * @param {string} messageType 'type of message, eg. error, info'
     * @param {string} messageText 'message text to be displayed'
     */

    emitMessageEvent(messageType, messageText) {
      window.photoClaim.$emit('message', [messageType, messageText]);
    },

    /**
     * @name getQueryVariable
     * @description get query var from URL
     * @param {string} variable URL query var key
     */
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
  computed: {
    isOSAndroid() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
          return true;
      }

      return false;
    },
    isBrowserFirefox() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    },
  },
};

export default appMixins;



// WEBPACK FOOTER //
// ./src/mixins/appMixins.js